import iconShare from 'assets/icons/share.svg'
import iconCheck from 'assets/icons/check.svg'

import { Device } from '../Device'
import './styles.scss'
import { useEffect, useRef, useState } from 'react'
import IconClose from 'components/Icons/Close'
import useCopy from 'use-copy'

interface ModalShareProps {
  showModal: boolean
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>
}
function ModalShare({ showModal, setShowModal }: ModalShareProps) {
  const device = Device.useDevice()

  const devicePrefix = device.prefix()

  const [currentUrl, setCurrentUrl] = useState(window.location.href)

  const refAreaModal = useRef<HTMLDivElement>(null)

  const [copied, copy, setCopied] = useCopy(window.location.href)

  useEffect(() => {
    return () => {
      setCurrentUrl('')
    }
  }, [])

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        refAreaModal.current != null &&
        !refAreaModal.current.contains(event.target as Node)
      ) {
        setShowModal(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [refAreaModal])

  function handleCopyLink() {
    copy()

    setTimeout(() => {
      setCopied(false)
    }, 2000)
  }

  return (
    <section className={`content-modalShare ${devicePrefix ?? 'undefined'}`}>
      <div ref={refAreaModal} className="container-modalShare">
        <div className="container-modalShare__header">
          <img src={iconShare} alt="icon search" />
          <div className="container-modalShare__header-titles">
            <h1>Compartilhar link da família</h1>
            <p>Copie o link da família para compartilhar com outros agentes</p>
          </div>

          <div className="container-modalShare__header-close">
            <div
              onClick={() => {
                setShowModal(false)
              }}
            >
              <IconClose />
            </div>

            <p>Fechar</p>
          </div>
        </div>

        <div className="container-modalShare__content">
          <div>{currentUrl}</div>
          <div className={copied ? 'copy copied' : 'copy'}>
            {copied && (
              <p>
                <img src={iconCheck} alt="check" />
                Link copiado
              </p>
            )}

            <button
              className={copied ? 'copy-button copied' : 'copy-button'}
              onClick={() => {
                handleCopyLink()
              }}
            >
              Copiar link
            </button>

            {copied && (
              <p style={{ visibility: 'hidden' }}>
                <img src={iconCheck} alt="check" />
                Link copiado
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default ModalShare
